export const language: any = {
  LabelFavorites: "အနှစ်သက်ဆုံး",
  LabelYouDontHaveRecipeAddYourFavoriteRecipe: `သင်၏ အနှစ်သက်ဆုံး အသုပ်မရှိသေးပါ။<br/>သင်နှစ်သက်သော အသုပ်ကို ထည့်ပါ!`,
  LabelDoYouWantUnSave: `ဤအသုပ်ကို မသိမ်းဆည်းတော့လိုသလား?`,
  save: "သိမ်းဆည်းမည်",
  unsave: "မသိမ်းဆည်း",
  OkFavorite: "ဟုတ်ကဲ့",
  CloseFavorite: "မလုပ်ပါ",
};
